import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import store from "./Store";
import { Footer, Header, Loading } from "Components";
import ReactGA from "react-ga4";
const TRACKING_ID = "G-GEXVL6ETTY"; // ANALYTICS TRACKING_ID
ReactGA.initialize(TRACKING_ID);
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Suspense>
  </Provider>
);

reportWebVitals();
